import { makeStyles } from '@material-ui/core/styles';

import transparentize from '@utils/transparentize';

const useStyles = makeStyles((theme) => ({
  plansWrapper: {
    marginTop: 28,
    position: 'relative',
    display: 'grid',
    gap: 40,
  },
  planImages: {
    display: 'none',
  },
  plan: {
    position: 'relative',
    backgroundColor: theme.palette.background.default,
    boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.15)',
    borderRadius: 40,
    padding: '48px 40px',
    width: '100%',
    height: '100%',
    '& h6': {
      marginBottom: 8,
    },
  },
  withBorder: {
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: theme.palette.primary.dark,
    padding: '44px 36px',
  },
  disabled: {
    color: theme.palette.info.main,
  },
  feature: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 24,
    '& > i': {
      marginRight: 12,
      fontSize: 24,
    },
  },
  pricesWrapper: {
    marginTop: 16,
    display: 'grid',
    marginBottom: 40,
  },
  twoColumns: {
    gridTemplateColumns: '1fr 1fr',
  },
  price: {
    '& p': {
      color: theme.palette.info.main,
    },
    '& h3': {
      color: theme.palette.secondary.dark,
    },
    '&:nth-child(2)': {
      paddingLeft: 12,
      borderLeftWidth: 1,
      borderLeftStyle: 'solid',
      borderLeftColor: transparentize(theme.palette.info.main, 0.3),
    },
  },
  button: {
    marginTop: 16,
    zIndex: 2,
  },
  red: {
    color: theme.palette.error.main,
  },
  green: {
    color: theme.palette.success.main,
  },
  [theme.breakpoints.up('sm')]: {
    plansWrapper: {
      gridTemplateColumns: '1fr 1fr',
      gap: 30,
      marginTop: 58,
      paddingBottom: 40,
    },
    button: {
      width: '100%',
    },
  },
  [theme.breakpoints.up('md')]: {
    plansWrapper: {
      gap: 190,
    },
    planImages: {
      display: 'block',
      zIndex: 0,
    },
    personMeditating: {
      left: 'calc(50% + 26px)',
      height: 390,
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
  [theme.breakpoints.up('lg')]: {
    plansWrapper: {
      gap: 410,
    },
    personMeditating: {
      height: 660,
      left: 'calc(50% + 50px)',
    },
  },
}));

export default useStyles;
